import { render, staticRenderFns } from "./NuevoProducto.vue?vue&type=template&id=063d6b9e"
import script from "./NuevoProducto.vue?vue&type=script&lang=js"
export * from "./NuevoProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports